import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  isMobileTabletDevice: boolean;
}

const initialState: InitialState = {
  isMobileTabletDevice: false,
};

const deviceDetection = createSlice({
  name: "Save the type of device",
  initialState,
  reducers: {
    saveDeviceType(state, action) {
      state.isMobileTabletDevice = action.payload.isMobileTabletDevice;
    },
  },
});

export const { saveDeviceType } = deviceDetection.actions;
export default deviceDetection.reducer;
